import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { EuiFlexGroup, EuiFlexItem, useEuiTheme } from "@elastic/eui";

const useStyles = createUseStyles({
  container: {
    display: "inline-flex",
    gap: "0px",
    background: "var(--card-background)",
    padding: "3px",
    border: "1px solid var(--border-color)",
    borderRadius: "var(--box-radius)",
    flexGrow: 0,
  },

  button: {
    fontWeight: 500,
    fontSize: "var(--fs12)",
    background: "var(--card-background)",
    color: "var(--text)",
    height: "30px",
    padding: "0 12px",
    cursor: "pointer",
    userSelect: "none",
    // prevent double borders between buttons
    marginLeft: "-1px",
    borderRadius: 0,
    border: "none",
  },

  selected: ({ theme }: any) => ({
    background: "var(--button-bg)",
    color: theme?.colorMode === "DARK" ? "#0a0e1a" : "var(--toggle-button-text)",
    borderRadius: "6px",
  }),
});

export default function ToggleButtons({
  labels,
  defaultSelectedIndex = 0,
  selectedIndex,
  onChange,
  disabled = [],
}: any) {
  const theme = useEuiTheme();
  const classes = useStyles({ theme });

  const [selected, setSelected] = useState(defaultSelectedIndex);

  useEffect(() => {
    if (selectedIndex !== undefined) {
      setSelected(selectedIndex);
    }
  }, [selectedIndex]);

  const handleClick = (index: number) => {
    setSelected(index);
    onChange?.(index);
  };

  return (
    <EuiFlexGroup>
      <EuiFlexItem grow={false}>
        <div className={classes.container}>
          {labels.map((label: any, index: number) => (
            <button
              key={index}
              className={`${classes.button} ${selected === index ? classes.selected : ""}`}
              disabled={disabled[index]}
              onClick={() => handleClick(index)}
              type="button">
              {label}
            </button>
          ))}
        </div>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
}
